import { Button, Modal, Typography } from 'antd'
import React from 'react'
const { Text } = Typography;

export default function SuccessUpload({ open, editConfigFun, reRnakFun }) {
    return (
        <Modal
            open={open}
            closeIcon={false}
            footer={[
                <Button key="submit" type="primary" onClick={reRnakFun}>
                    Rank
                </Button>,
                <Button
                    key="submit"
                    type="default"
                    onClick={editConfigFun}
                >
                    Edit Configuration
                </Button>,
            ]}
        >
            <div style={{ padding: '10px' }}>
                <Text strong style={{ fontSize: "16px" }}>
                    Edit configuration or rank directly ?
                </Text>
            </div>
        </Modal>
    )
}
